module.exports = __webpack_public_path__ + "img/马蜂窝_02.938186a8.jpg";